









































import { Component, Vue } from 'vue-property-decorator'
import { healthCertBatchResult, healthCertBatchCerts, healthCertQuery } from '@/api/order'

@Component({})
export default class extends Vue {
  private batchNo1 = ''
  private batchNo2 = ''
  private zjhm = ''
  private result1 = ''
  private result2 = ''
  private result3 = ''
  private loading1 = false
  private loading2 = false
  private loading3 = false

  private async doQueryResult() {
    if (!this.batchNo1) {
      this.$message.warning('请输入批次号')
      return
    }
    this.loading1 = true
    try {
      const res: any = await healthCertBatchResult({ batchNo: this.batchNo1 })
      this.result1 = JSON.stringify(res.data, null, 2)
    } catch (e: any) {
      this.result1 = '查询失败: ' + (e.message || e)
    } finally {
      this.loading1 = false
    }
  }

  private async doQueryCerts() {
    if (!this.batchNo2) {
      this.$message.warning('请输入批次号')
      return
    }
    this.loading2 = true
    try {
      const res: any = await healthCertBatchCerts({ batchNo: this.batchNo2 })
      this.result2 = JSON.stringify(res.data, null, 2)
    } catch (e: any) {
      this.result2 = '查询失败: ' + (e.message || e)
    } finally {
      this.loading2 = false
    }
  }

  private async doQueryByZjhm() {
    if (!this.zjhm) {
      this.$message.warning('请输入证件号码')
      return
    }
    this.loading3 = true
    try {
      const res: any = await healthCertQuery({ zjhm: this.zjhm })
      this.result3 = JSON.stringify(res.data, null, 2)
    } catch (e: any) {
      this.result3 = '查询失败: ' + (e.message || e)
    } finally {
      this.loading3 = false
    }
  }
}
